import { render, staticRenderFns } from "./TheDocuments.vue?vue&type=template&id=6fe64bf2&scoped=true"
import script from "./TheDocuments.vue?vue&type=script&lang=ts"
export * from "./TheDocuments.vue?vue&type=script&lang=ts"
import style0 from "./TheDocuments.vue?vue&type=style&index=0&id=6fe64bf2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fe64bf2",
  null
  
)

export default component.exports